import { difference, intersection, size } from "lodash";

export default function getAllPermissionLogged() {
  const loggedUser = JSON.parse(
    window.localStorage.getItem("loggedUser") || "{}"
  );

  const papel = loggedUser.papel;
  const permissions =
    papel?.papelPermissoes?.map((x) => x?.permissoes?.chave) || [];
  return permissions;
}

export const hasPermission = (requiredPermissions, shouldHaveAll = true) => {
  const userPermissions = getAllPermissionLogged();
  if (shouldHaveAll) {
    return size(difference(requiredPermissions, userPermissions)) == 0;
  }
  return size(intersection(requiredPermissions, userPermissions)) > 0;
};

export function isLoggedUser(cpf) {
  const loggedUser = JSON.parse(
    window.localStorage.getItem("loggedUser") || "{}"
  );
  console.log("cpf:" + cpf);
  console.log("cpf logado:" + loggedUser.cpf);
  return cpf == loggedUser.cpf;
}
